import { Badge, t } from '@kanbios/ui';

type Observed = 'concordant' | 'gap' | 'degraded' | 'maintenance' | 'unknown';
const OBSERVED_TONE: Record<Observed, 'pos' | 'warn' | 'neg' | 'neutral'> = { concordant: 'pos', gap: 'warn', degraded: 'neg', maintenance: 'neutral', unknown: 'neutral' };
const STATE_TONE: Record<string, 'pos' | 'warn' | 'neg' | 'neutral'> = {
  in_service: 'pos', deployed: 'pos', failed: 'neg', retire_requested: 'warn', retiring: 'warn', unlinking: 'warn', purging: 'warn', resetting: 'warn',
};

/**
 * D96: one status for a deployment, the same in its page's header and in its project's list — what runs (the
 * observed version, SPEC-034 § 9) once it was read on the server, else the installation's state.
 */
export function DeploymentStatus({ state, observed, size }: { state: string; observed: Observed | null | undefined; size?: 'sm' }) {
  if (observed && observed !== 'unknown') return <Badge tone={OBSERVED_TONE[observed]} size={size}>{t(`environment.observed.${observed}`)}</Badge>;
  return <Badge tone={STATE_TONE[state] ?? 'neutral'} size={size}>{t(`environment.state.${state}`)}</Badge>;
}
